import styled from 'styled-components';
import {
	EXCHANGE_COLLATERAL_POPUP_BG,
	EXCHANGE_COLLATERAL_INSUFFICIENT_BG
} from '../../config/media';

const Wrapper = styled.div`
	color: #000000;
	.collateral-header {
		width: 100%;
		height: 220px;
		background-image: url(${EXCHANGE_COLLATERAL_POPUP_BG});
		background-size: cover;
		background-repeat: no-repeat;
		padding-left: 120px;
		box-sizing: border-box;
		position: relative;
		img {
			width: 90px;
			position: absolute;
			left: 15px;
			top: 45px;
		}
		h2 {
			font-size: 35px;
			line-height: 1.1;
			font-weight: bold;
			padding-top: 45px;
			margin: 0;
			color: #000;
		}
		p {
			font-size: 12px;
			line-height: 1.2;
			padding-top: 8px;
			padding-right: 45px;
		}
	}
	.info-box {
		text-align: center;
		padding: 24px;
		&.step2 {
			text-align: left;
			.stat-info {
				font-size: 18px;
				margin-top: 8px;
				margin-bottom: 8px;
			}
			.ant-btn-primary {
				margin-top: 8px;
			}
			.d-flex {
				display: flex;
			}
			.xht-icon {
    			width: 20px;
				margin: 0 6px;
			}
			.anchor {
				color: #3A4FFF;
				text-decoration: underline;
				cursor: pointer;
			}
			h2 {
				font-size: 24px;
				font-weight: bold
			}
			.address-content {
				margin: 2rem 0;
				span {
					margin-bottom: 20px;
				}
			}
		}
		p {
			margin-bottom: 0;
		}
		b {
			color: #000;
		}
		.collater-info {
			display: flex;
			align-items: center;
			padding: 8px 0;
    		margin-bottom: 1rem;

			> div {
				flex: 1;
				> img {
					width: 60px;
				}
			}
			.stat-info {
				flex: 2;
				text-align: left;
    			padding-left: 25px;
				box-sizing: border-box;
    			border-left: 1px solid #A7A7A7;
				p {
					line-height: 1.4;
				}
				.no-exchange {
					padding-top: 4px;
				}
				.large-txt {
					font-size: 20px;
    				margin-top: 1rem;
				}
				.xht-icon {
    				width: 20px;
				}
				.m-1 {
					margin: 1rem 0;
				}
				.rmv-process-wrapper {
					display: flex;
					// white-space: nowrap;
				}
				.progress-bar {
					height: 15px;
					width: 100%;
					margin: 3px 0px 0px 5px;
					background-color: #C7C7C7;
					.progress-bar-blue {
						background-color: #0000FF;
					}
				}
			}
			.img-wrapper {
				margin-left: 1rem;
				padding-right: 8px;
			}
			.small-txt {
				font-size: 12px;
			}
		}
		.footer {
			font-size: 12px;
			margin-bottom: 2rem;
		}
	}
	${'' /* .input-container {
		p {
			font-weight: bold;
			color: #000;
			text-align: left;
		}
		.error {
			height: 24px;
			line-height: 22px;
			color: red;
			font-weight: normal;
			font-size: 12px;
			text-align: left;
			text-indent: 59px;
		}
		.max {
			cursor: pointer;
			color: #00f;
		}
		.ant-input {
			border-top-color: #000FFF;
    		border-bottom-color: #000FFF;
		}
	} */}
	${'' /* .switch-container {
		padding: 26px;
		padding-bottom: 32px;
		width: 50%;

		.on {
			font-weight: bold;
		}
		.text {
			display: inline-block;
			width: 55px;
			position: relative;
			line-height: 22px;
			background-color: #fff;
		}
		.disclamar {
			line-height: 1.4;
			font-weight: normal;
			font-style: normal;
			border-radius: 5px;
			position: absolute;
			left: 35px;
			top: -20px;
			text-align: left;
			width: 181px;
			padding: 8px;
			padding-left: 20px;
			box-sizing: content-box;
			border: 1px solid #b9b9b9;
			font-size: 10px;
		}
	} */}
	.insufficient-header {
		width: 100%;
		height: 180px;
		background-image: url(${EXCHANGE_COLLATERAL_INSUFFICIENT_BG});
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		padding-left: 44px;
		box-sizing: border-box;
		position: relative;
		padding-top: 30px;
		padding-right: 90px;
		color: #fff;
		img {
			position: absolute;
			left: 10px;
			top: 13px;
			width: 80px;
		}
		h2 {
			font-size: 35px;
			font-weight: bold;
			color: #fff;
		}
	}
	@media (max-width: 1200px) {
		.collateral-header {
			height: 200px;
			padding-left: 0;
			box-sizing: border-box;
			position: relative;
			padding-left: 12px;
			img {
				display: none;
			}
			h2 {
				font-size: 28px;
				line-height: 32px;
				font-weight: bold;
				padding-top: 12px;
				margin: 0;
				color: #000;
			}
			p {
				font-size: 12px;
				line-height: 1.2;
				padding-top: 8px;
				padding-right: 12px;
			}
		}
		.info-box {
			padding: 12px;
			&.step2 {
				.stat-info {
					font-size: 13px;
					margin-top: 4px;
					margin-bottom: 4px;
					p {
						white-space: nowrap;
					}
				}
				.ant-btn-primary {
					margin-top: 4px;
				}
			}
			.user-info {
				padding: 4px 0;
			}
			.collater-info {
				padding: 4px 0;
				margin-bottom: 12px;
			}
			.rmv-process-wrapper {
				flex-direction: column;
			}
		}
		.insufficient-header {
			width: 100%;
			height: 160px;
			padding-left: 12px;
			padding-top: 12px;
			padding-right: 12px;
			color: #fff;
			img {
				display: none;
			}
			h2 {
				color: #fff;
			}
			p {
				font-size: 14px;
				line-height: 1.2;
				padding-top: 8px;
			}
		}
	}
	
	.btn-wrapper {
		display: flex;
		justify-content: space-between;
		margin-top: 1rem;
		.ant-btn:last-child {
			margin-left: 20px;
		}
	}

	.step3-container {
		padding: 24px;
		h2 {
			font-size: 35px;
			font-weight: bold;
			color: #000;
		}
		.box-container {
			width: 100%;
			border: 1px solid #707070;
			margin-top: 2rem;
			padding-bottom: 2rem;
			.box-title {
				width: 22%;
				position: relative;
				z-index: 5;
				bottom: 14px;
				left: 20px;
				background-color: #fff;
				text-align: center;
    			color: #787878;
			}
			.flex-container {
				display: flex;
				flex-direction: column;
    			padding: 0 25px;
				img {
					width: 80px;
				}
			}
    	}
	}
	.step4-content {
		padding: 30px;
		h2 {
			font-size: 35px;
			font-weight: bold;
			color: #000;
			margin-top: 0;
			margin-bottom: 0;
		}
		.ant-input {
    		margin: 10px 0 1rem 0;
		}
	}
	.success-image {
    	// height: 426px;
		background-size: cover;
		position: relative;
		overflow: hidden;
		video {
			width: 100%;
		}
	}
`;

export default Wrapper;
